<template>
  <div
    class="layout_row layrow full_screen_banner my_banner"
    :id="'u' + banner.widgets_id"
    :data-id="banner.widgets_id"
  >
    <!--右上角门板-->
    <div class="edit_tool_banner" :style="editBtnStyle">
      <div class="edit_tool_wrap">
        <div class="jz_edit_btn" @click="edit_banner" :title="$t('widgets_full_screen_banner_index_2924')">
          <div class="jz_edit_item el-icon-edit"></div>
        </div>
        <div
          class="edit_btn_text"
          :title="
            banner.data.banner_type === 'private'
              ? $t('widgets_full_screen_banner_index_2925')
              : ''
          "
        >
          <div
            class="jz_edit_item"
            v-if="banner.data.banner_type === 'private'"
            @click="banner_type_change('share')"
          >{{$t('widgets_full_screen_banner_index_2926')}}</div>
          <div
            class="jz_edit_item"
            v-else
            @click="banner_type_change('private')"
          >{{$t('widgets_full_screen_banner_index_2927')}}</div>
        </div>
        <div
          class="jz_edit_btn"
          @click="full_screen_banner_isShow"
          :title="$t('widgets_full_screen_banner_index_2928')"
          v-if="$store.state.app.view_pattern == 'pc'"
        >
          <div class="jz_edit_item el-icon-view"></div>
        </div>
      </div>
    </div>

    <!-- <div class="now_type">当前是：{{banner.data.banner_type === 'private' ? '私有' : '共享'}}模式</div> -->

    <div class="laybox">
      <div class="laybox_child_frame">
        <!--轮播模式-->
        <template
          v-if="banner.data.listArr.full_screen_banner_pattern === 'banner'"
        >
          <div
            :class="['banner_frame',backgroundClass]"
            :style="{
              width:
                banner.data.infor.banner_size[
                  banner.data.infor.banner_size.radio_val
                ].width,
              minHeight: banner_height + 'px'
            }"
          >
            <img
              :src="
                banner.children.length > 0 &&
                banner.children[0].data.full_screen_banner.src
              "
              :alt="
                banner.children.length > 0 &&
                banner.children[0].summary
              "
              :title="
                banner.children.length > 0 &&
                banner.children[0].summary
              "
              class="first_img"
              @load="img_load"
              id="full_screen_banner_first_img"
            />
            <swiper
              ref="mySwiper"
              class="full_screen_banner_swiper"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="(column, i) in slideList"
                :key="column.widgets_id"
                :alt="column.summary"
                :title="column.summary"
                :style="{
                  backgroundImage:
                    'url(' + column.data.full_screen_banner.src + ')',
                  backgroundSize:
                    banner.data.infor.backgroundSize.radio_val === 'default'
                      ? banner.data.infor.backgroundSize.default.backgroundSize
                      : banner.data.infor.backgroundSize.custom.backgroundSize,
                }"
              >
                <layout_column
                  :column="column"
                  :row="banner"
                  :col_index="i"
                  :key="i"
                ></layout_column>
                <set_link
                  class="linkPart"
                  :sendData="column.data.full_screen_banner.link"
                ></set_link>
              </swiper-slide>
            </swiper>

            <template v-if="banner.children.length > 2">
              <!--分页器-->
              <template v-if="banner.data.infor.swiper_type === 'pagination'">
                <div
                  class="pic_switch_btn_area clear_fix banner_short_line_wrap"
                  :class="
                    $store.state.app.language != 'zh-cn' &&
                    banner.data.infor.banner_set.radio_val === 'custom'
                      ? 'abroad_page'
                      : ''
                  "
                >
                  <div
                    :index="i"
                    class="pic_short_line_btn"
                    v-for="(column, i) in slideList"
                    :key="column.widgets_id"
                    @click="pagination_change(column, i)"
                    :class="index == i ? 'pic_short_line_btn_activity' : ''"
                    :style="paginationBackground(i,column, index == i)"
                  >
                    <div class="pic_short_line"
                         :style="{opacity:index==i?0:1,...hover0(column,i)}"
                         @mouseenter="onMouseEnterPagination(column,i)"
                         @mouseleave="onMouseLeavePagination(column,i)"></div>
                  </div>
                </div>
              </template>

              <!--块级按钮-->
              <template v-if="banner.data.infor.swiper_type === 'block_btn'">
                <div
                  class="pic_arrow_btn_prev banner_btn"
                  :style="paginationStyle2('left')"
                  @click="banner_prev"
                  @mouseenter="onMouseEnterPagination({},'left')"
                  @mouseleave="onMouseLeavePagination({},'left')"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="pic_arrow_btn_next banner_btn"
                  :style="paginationStyle2('right')"
                  @click="banner_next"
                  @mouseenter="onMouseEnterPagination({},'right')"
                  @mouseleave="onMouseLeavePagination({},'right')"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </template>

              <!--箭头按钮-->
              <template v-if="banner.data.infor.swiper_type === 'arrow_btn'">
                <div
                  class="arrow_btn_prev arrow_btn"
                  @click="banner_prev"
                >
                  <i class="style-1-icon el-icon-arrow-left" :style="paginationStyle1()"></i>
                  <span class="mock-after" :style="paginationStyle1After()"></span>
                </div>
                <div
                  class="arrow_btn_next arrow_btn"
                  @click="banner_next"
                >
                  <i class="style-1-icon el-icon-arrow-right" :style="paginationStyle1()"></i>
                  <span class="mock-after" :style="paginationStyle1After()"></span>
                </div>
              </template>

              <!--上下按钮-->
              <template
                v-if="banner.data.infor.swiper_type === 'top_bottom_arrow'"
              >
                <div class="top_bottom_arrow_frame">
                  <div
                    class="fk_rightColorArrowsImg fk_rightColorArrowsImg_prev"
                    :style="paginationStyle2('top')"
                    @click="banner_prev"
                    @mouseenter="onMouseEnterPagination({},'top')"
                    @mouseleave="onMouseLeavePagination({},'top')"
                  >
                    <i class="el-icon-arrow-left"></i>
                  </div>
                  <div class="f-horizontal-line_frame">
                    <div class="f-horizontal-line"></div>
                  </div>
                  <div
                    class="fk_rightColorArrowsImg fk_rightColorArrowsImg_next"
                    :style="paginationStyle2('bottom')"
                    @click="banner_next"
                    @mouseenter="onMouseEnterPagination({},'bottom')"
                    @mouseleave="onMouseLeavePagination({},'bottom')"
                  >
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </template>

              <template
                v-if="banner.data.infor.swiper_type === 'big_block_btn'"
              >
                <div class="big_block_btn_frame">
                  <div
                    class="one_big_block"
                    v-for="(column, i) in slideList"
                    :key="column.widgets_id"
                    :style="{
                      backgroundImage:
                        'url(' + column.data.full_screen_banner.src + ')',
                        ...paginationStyleBigBlockBtn(i,column, i==index),
                        ...hover5(column,i)
                    }"
                    :class="index == i ? 'big_block_btn_select' : ''"
                    @click="pagination_change(column, i)"
                    @mouseenter="onMouseEnterPagination(column,i)"
                    @mouseleave="onMouseLeavePagination(column,i)"
                  ></div>
                </div>
              </template>

              <template
                v-if="banner.data.infor.swiper_type === 'pagination_num'"
              >
                <div class="imageSwitchBtnArea imageSwitchBtnArea_clearFix">
                  <div class="fk_adsorptionRound_current" :style="{
                    transform:'translate3d(' + (index + 1)*44 + 'px, 0px, 0px) scale(1.5, 1.5)',
                    backgroundColor:banner.data.infor.banner_btn_color[banner.data.infor.banner_btn_color.radio_val].seColor,
                  }"></div>
                  <div class="fk_imageSwitchBtn_adsorptionRound" v-for="(column, i) in cols"
                       :key="column.widgets_id"
                       :style="{
                         ...hover4(column,i,i==index),
                         backgroundColor:index==i?banner.data.infor.banner_btn_color[banner.data.infor.banner_btn_color.radio_val].seColor:banner.data.infor.banner_btn_color[banner.data.infor.banner_btn_color.radio_val].color,
                      }"
                       @click="pagination_change(column, i)"
                       @mouseenter="onMouseEnterPagination(column,i)"
                       @mouseleave="onMouseLeavePagination(column,i)"
                  >
                    <span class="fk_adsorptionRound_num" :class="index == i ? 'fk_adsorptionRound_num_activity' : ''"
                          :style="{
                        color:banner.data.infor.num_color[banner.data.infor.num_color.radio_val].color
                      }">{{ i + 1 }}</span>
                  </div>
                  <svg style="height: 0;" xmlns="http://www.w3.org/2000/svg" version="1.1" width="740">
                    <defs>
                      <filter id="AR">
                        <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"></feGaussianBlur>
                        <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 15 -5"
                                       result="AR"></feColorMatrix>
                        <feBlend in="SourceGraphic" in2="AR"></feBlend>
                      </filter>
                    </defs>
                  </svg>
                </div>
              </template>
            </template>

            <div class="animation-hook"></div>
          </div>
        </template>
        <!--视频模式-->
        <template v-else>
          <div
            class="video_frame"
            :class="
              $store.state.app.view_pattern === 'pc'
                ? 'pc_video_frame'
                : 'mb_video_frame'
            "
            :style="{
              minHeight: video_height + 'px',
            }"
          >
            <layout_column
              v-for="(column, i) in banner.children"
              :column="column"
              :row="banner"
              :col_index="i"
              :key="i"
              v-if="column.data.full_screen_banner_pattern === 'video'"
            ></layout_column>
            <video
              :src="banner.data.listArr.video"
              class="full_screen_video"
              autoplay
              muted="muted"
              loop="loop"
              v-if="$store.state.app.view_pattern === 'pc'"
            ></video>
            <video
              :src="banner.data.listArr.video"
              class="full_screen_video mb_full_screen_video"
              :poster="banner.data.listArr.poster"
              controls
              v-else
            ></video>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import layout_column from "../layout_column/index";
import {full_screen_banner_new_style} from "@/base/widgets_data_compatible";
import SlideAnimation from './../../base/slideAnimation'

export default {
  name: "full_screen_banner",
  props: {
    banner: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      index: 0,
      height: 0,
      currentHoverIndex: null
    };
  },
  methods: {
    banner_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    banner_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    col_sort_init() {
      const doms = $(".full_screen_banner").find(".sort_modules");
      for (let i = 0; i < doms.length; i++) {
        this.templet.module_sortable("", $(doms[i]));
      }
    },
    //开启共享横幅
    banner_type_change(val) {
      this.templet.dialog_close();
      //切换需要重新走横幅流程
      this.$store.commit("myRender/set_banner_type", "");
      this.$nextTick(() => {
        this.$store.commit("myRender/set_banner_type", val);
        this.$store.state.full_screen_banner.isRender = false;
        this.$nextTick(() => {
          this.$store.state.full_screen_banner.isRender = true;
        });
      });
    },
    fixBannerEditBtnPosition() {
      let headerIsZhanwei = this.$store.state.myRender.private.fullPageTopNavType === 'zhanwei'
      if (!headerIsZhanwei) {
        $('.full_screen_banner .edit_tool_banner').css({
          top: $('.myheader').height()
        })
      } else {
        $('.full_screen_banner .edit_tool_banner').css({
          top: 0
        })
      }
    },
    img_load(e) {
      const h = $("#full_screen_banner_first_img").height();
      //如果在默认情况下，且没有高度值的情况下，去用第一张图片计算高度百分比
      const radio_val = this.banner.data.infor.banner_size.radio_val;
      const num = this.banner.data.infor.banner_size.default.height;

      let isFrist = false;
      if (num == "" || parseFloat(num) <= 0) {
        isFrist = true;
      }

      if (radio_val === "default" && isFrist) {
        this.templet.banner_calculation_height_Percent(
          this.banner.data.infor,
          h
        );
      }
    },
    edit_banner() {
      this.$store.commit("app/SET_module_Data", this.banner);
      this.$store.commit("main_dialog/Change_main_dialog_isShow", true);
      this.$store.commit("main_dialog/Change_edit_name", this.banner.name);
    },
    pagination_change(column, index) {
      this.$refs.mySwiper.swiper.slideTo(index, 300, false);
      this.index = index;
    },
    full_screen_banner_isShow() {
      this.templet.dialog_close();
      this.$store.state.myRender.private.banner_isShow = false;
      this.$message({
        showClose: true,
        type: "warning",
        message: i18n.t('base_row_jcp_1920'),
      });
    },
    switch_stop_init() {
      const that = this;
      $(`#u${this.banner.widgets_id}`)
        .find(".full_screen_banner_swiper")
        .find(".swiper-slide")
        .mouseenter(function () {
          that.$refs.mySwiper.swiper.autoplay.stop();
        });

      $(`#u${this.banner.widgets_id}`)
        .find(".full_screen_banner_swiper")
        .find(".swiper-slide")
        .mouseleave(function () {
          // console.log(that.$store.state.app.main_dialog_close_IsShow)
          if (
            that.banner.data.infor.banner_set.radio_val != "autoplay_false" &&
            !that.$store.state.main_dialog.main_dialog_isShow
          ) {
            that.$refs.mySwiper.swiper.autoplay.start();
          }
        });
    },
    screen_width_init() {
      if (this.$store.state.app.view_pattern === "pc") {
        this.$store.state.app.screenWidth = $(window).width();
      } else {
        this.$store.state.app.screenWidth = 375;
      }
    },
    module_animate() {
      //只触发当前状态下的，选中页下的，module动画
      const slide = $(`#u${this.banner.widgets_id}`)
        .find(".swiper-slide")
        .eq(this.index);
      const doms = slide.find(".module");
      const implement = this.$store.state.moduleAnimation.implement;
      for (let i = 0; i < doms.length; i++) {
        const id = $(doms[i]).attr("id").replace("u", "");
        for (let j = 0; j < implement.length; j++) {
          if (implement[j].module.widgets_id == id) {
            implement[j].vue.animation(doms[i]);
            //console.log(doms[i],implement[j].vue.isNotVisibleInViewport)
            break;
          }
          implement[j].vue.isNotVisibleInViewport = true;
        }
      }
    },
    create_data() {
      const infor = this.banner.data.infor;
      const data = full_screen_banner_new_style();
      if (typeof infor.banner_btn_color == "undefined") {
        this.$set(infor, "banner_btn_color", data.banner_btn_color);
        this.$set(infor, "num_color", data.num_color);
      }
      if (!this.banner.data.infor.banner_btn_color.custom.seColor) {
        this.$set(this.banner.data.infor.banner_btn_color.custom, 'seColor', this.banner.data.infor.banner_btn_color.custom.color || 'rgba(133,133,133, 1)')
      }
    },
    paginationBackground(index, item, isActive) {
      if (this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      return {
        backgroundColor: isActive ? backgroundInfo[backgroundInfo.radio_val].seColor : backgroundInfo[backgroundInfo.radio_val].color,
      }
    },
    paginationStyle1(direction) {
      if (this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      let style = {}
      if (this.banner.data.infor.num_color.radio_val === 'custom') {
        style.color = this.banner.data.infor.num_color.custom.color
      }
      return style
    },
    paginationStyle1After() {
      if (this.banner.data.infor.num_color.radio_val === 'default') {
        return
      }
      return {
        backgroundColor: this.banner.data.infor.num_color.custom.color
      }
    },
    paginationStyle2(direction) {
      if (this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      let style = {
        backgroundColor: direction === this.currentHoverIndex ? backgroundInfo[backgroundInfo.radio_val].seColor : backgroundInfo[backgroundInfo.radio_val].color,
      }
      if (this.banner.data.infor.num_color.radio_val === 'custom') {
        style.color = this.banner.data.infor.num_color.custom.color
      }
      return style
    },
    paginationStyleBigBlockBtn(index, item, isActive) {
      if (this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      return {
        borderColor: isActive || item.isHover ? backgroundInfo[backgroundInfo.radio_val].seColor : backgroundInfo[backgroundInfo.radio_val].color,
      }
    },
    onMouseEnterPagination(item, index) {
      this.currentHoverIndex = index
    },
    onMouseLeavePagination(item, index) {
      this.currentHoverIndex = null
    },
    hover0(item, index) {
      if (index !== this.currentHoverIndex || this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      return {
        backgroundColor: backgroundInfo[backgroundInfo.radio_val].seColor
      }
    },
    hover4(item, index, isActive) {
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      if ((index !== this.currentHoverIndex && !isActive) || this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {
          backgroundColor: backgroundInfo[backgroundInfo.radio_val].color
        }
      }
      return {
        backgroundColor: backgroundInfo[backgroundInfo.radio_val].seColor
      }
    },
    hover5(item, index) {
      if (index !== this.currentHoverIndex || this.banner.data.infor.banner_btn_color.radio_val === 'default') {
        return {}
      }
      let backgroundInfo = this.banner.data.infor.banner_btn_color
      return {
        borderColor: backgroundInfo[backgroundInfo.radio_val].seColor
      }
    },
  },
  watch: {
    "$store.state.main_dialog.edit_name"(val) {
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        if (val != "") {
          this.$refs.mySwiper.swiper.autoplay.stop();
        } else {
          if (this.banner.data.infor.banner_set.radio_val != "autoplay_false") {
            this.$refs.mySwiper.swiper.autoplay.start();
          }
        }
      }
    },
    'banner.data.infor.swiper_type'() {
      if (this.banner.data.listArr.animateObj) {
        this.templet.full_banner_render();
      }
    },
    'banner.data.listArr.animateObj'() {
      if (this.banner.data.listArr.animateObj) {
        this.templet.full_banner_render();
      }
    },
  },
  computed: {
    isFullPage() { // 如果是全屏滚动的页面 设置的最小高度 应该和banner的高度没有关系 
      return this.$store.state.app.scrollType !== 'normal'
    },
    //通过屏幕宽度或高度百分比或高度百分比计算出最小高度
    banner_height() {
      //最小高度用end_set_height做计算
      const minHeight = this.templet.banner_calculation_minHeight(
        this.banner.data.infor
      );
      if(!this.isFullPage || this.$store.state.app.view_pattern != 'pc'){
        return minHeight;
      } else {
        // 要判断导航栏是不是固定的 这边的判断要看导航是不是占位
        let header_height = 0
        // Store.state.myRender.private.fullPageTopNavType
        // 要判断导航是否占位
        let is_zhanwei = this.$store.state.myRender.private.fullPageTopNavType != 'xuanfu'
        // console.log('占不占位置', is_zhanwei)
        if(is_zhanwei) {
          if(this.$store.state.myRender.common.fixed_header == 'true'){
            header_height = this.$store.state.myRender.common.fixed_height === 'all' ? $('.layout_header').height() : $('.layout_header .layout_row.system_row').height()
          } else header_height =  $('.layout_header').height() 

        }
        
        // console.log(header_height,document.documentElement.clientHeight )
        return document.documentElement.clientHeight - header_height
      }
      
    },
    video_height() {
      return this.templet.video_calculation_minHeight(this.banner.data.infor);
    },
    needSlideAnimation() {
      let animationList = ['bar', 'barHorizontal', 'barCube', 'barUpDown']
      let effectMap = {
        0: 'slide',
        1: 'fade',
        2: 'flip',
        3: 'cube',
        4: 'bar',
        5: 'barHorizontal',
        6: 'barCube',
        7: 'barUpDown'
      }
      let effectId = (this.banner.data.listArr.animateObj || {}).value || 0
      let effect = effectMap[effectId]
      return animationList.includes(effect)
    },
    swiperOption() {
      let effectMap = {
        0: 'slide',
        1: 'fade',
        2: 'flip',
        3: 'cube',
        4: 'bar',
        5: 'barHorizontal',
        6: 'barCube',
        7: 'barUpDown'
      }
      let effectId = (this.banner.data.listArr.animateObj || {}).value || 0
      let effect = effectMap[effectId]
      let slideAnimation
      this.needSlideAnimation && (slideAnimation = new SlideAnimation({}))
      // this.needSlideAnimation && slideAnimation && slideAnimation.init({
      //   slideList: this.slideList,
      //   animationType: effect
      // })
      const obj = {
        myVm: this,
        loop: false,
        direction: "horizontal",
        simulateTouch: false,
        observer: true,
        observeParents: true,
        effect: this.needSlideAnimation ? 'fade' : effect,
        // speed: this.needSlideAnimation ? 1800 : 600,
        speed: 600,
        on: {
          init: function () {
            // console.log(636, 'init', this)
            const that = this.passedParams.myVm;
            that.index = 0;
            that.switch_stop_init();
            that.needSlideAnimation && slideAnimation && slideAnimation.init({
              slideList: that.slideList,
              animationType: effect
            })
          },
          activeIndexChange() {
            // console.log('activeIndexChange')
            const that = this.passedParams.myVm;
            slideAnimation && slideAnimation.el && slideAnimation.entrance(this.activeIndex, that.index)
          },
          beforeSlideChangeStart() {
            // console.log('beforeSlideChangeStart')
          },
          transitionStart() {
            // console.log(654, 'transitionStart')
          },
          slideChangeStart() {
            // console.log('slideChangeStart')
          },
          slideChangeTransitionStart: function () {
            // console.log('slideChangeTransitionStart', arguments)
            // slideAnimation.entrance()
          },
          slideChangeTransitionEnd: function () {
            // console.log('slideChangeTransitionEnd')
          },
          slideNextTransitionStart: function () {
            // console.log('slideNextTransitionStart')
          },
          slideNextTransitionEnd: function () {
            // console.log('slideNextTransitionEnd')
          },
          slideChange: function (e) {
            const that = this.passedParams.myVm;
            // console.log('slideChange', e)
            // console.log('this.activeIndex:', this.activeIndex)
            // console.log('that.index:', that.index)
            // console.log('this.activeIndex:', this.activeIndex)
            that.index = this.activeIndex;
            that.module_animate();
            // console.log('that.slideList:', that.slideList)
          },
          setTransition: function (e) {
            //自定义事件
            // console.log('setTransition 自定义事件', e)
            // console.log(arguments)
          },
        },
      };

      const autoplay = this.templet.autoplay_obj(
        this.banner.data.infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    cols() {
      const child = this.banner.children;
      let r = []
      for (let i = 0; i < child.length; i++) {
        if (child[i].data.full_screen_banner_pattern === 'banner') {
          r.push(child[i]);
        }
      }
      return r;
    },
    infor() {
      return this.$store.state.app.module_Data.data.infor;
    },
    slideList() {
      return this.banner.children.filter(banner => {
        return banner.data.full_screen_banner_pattern === 'banner'
      })
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    editBtnStyle() {
      let headerIsShow = String(this.$store.state.myRender.common.header_display) === 'true'
      let headerIsXuanfu = this.$store.state.myRender.private.fullPageTopNavType === 'xuanfu'
      if (this.isFullPage && headerIsShow && headerIsXuanfu) {
        return {
          top: $('.myheader').height() + 'px',
        }
      } else {
        return {
          top: 0,
        }
      }
    },
    backgroundClass() {
      return (this.banner.data.infor.backgroundSize.radio_val === 'auto' || (this.banner.data.infor.backgroundSize[this.banner.data.infor.backgroundSize.radio_val] || {}).backgroundSize === 'auto') ? 'bg-auto' : ''
    }
  },
  components: {
    layout_column,
  },
  created() {
    if (!this.banner.data.infor.end_set_height) {
      this.$set(this.banner.data.infor, "end_set_height", "30%");
    }
    this.create_data();
  },
  mounted() {
    //this.col_sort_init();
    $(window).resize(() => {
      this.screen_width_init();
    });
    this.$store.state.full_screen_banner.full_screen_banner_infor = this.banner.data.infor;
  },
};
</script>

<style lang="scss" scoped>

.my_banner .banner_btn {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-image: none;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 10;
  background-color: rgba(0, 0, 0, .1);
  border-radius: 6px;
  top: calc(50% - 30px);
  cursor: pointer;
  color: #fff;
  font-size: 40px;
}

.top_bottom_arrow_frame .fk_rightColorArrowsImg {
  position: relative;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  color: #fff;
  font-size: 40px;
}

//第1(2)种样式的翻页
.full_screen_banner .arrow_btn {
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  overflow: hidden;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  z-index: 3;
  -webkit-tap-highlight-color: transparent;
  color: #4c4c4c;
  font-size: 40px;
  background-image: none;

  .style-1-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
    width: 40px;
    height: 40px;
    left: 15px;
  }
}

.full_screen_banner .arrow_btn_next .mock-after,
.full_screen_banner .arrow_btn_prev .mock-after {
  width: 0;
  height: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #4c4c4c;
  -webkit-transition: all .4s cubic-bezier(.215, .61, .355, 1) 0s;
  -o-transition: all .4s cubic-bezier(.215, .61, .355, 1) 0s;
  -moz-transition: all .4s cubic-bezier(.215, .61, .355, 1) 0s;
  transition: all .4s cubic-bezier(.215, .61, .355, 1) 0s;
}

.full_screen_banner .arrow_btn_next .mock-after {
  right: 25px;
}

.full_screen_banner .arrow_btn_next:hover .mock-after {
  width: 20px;
  right: 35px;
}

.full_screen_banner .arrow_btn_prev .mock-after {
  left: 28px;
}

.full_screen_banner .arrow_btn_prev:hover .mock-after {
  width: 20px;
  left: 38px;
}

.full_screen_banner {
  .jz_edit_btn:hover,
  .edit_btn_text:hover {
    background-color: #2e343b;
  }
}

.top_bottom_arrow_frame {
  width: 60px;
  position: absolute;
  right: 1%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  .fk_rightColorArrowsImg {
    position: relative;
    width: 60px;
    height: 60px;
    background-color: rgba(0, 0, 0, 0.4);
    cursor: pointer;

    p {
      width: 100%;
      height: 100%;
      background-image: url(/static/image/backimg1.png);
      background-repeat: no-repeat;
      transform: scale(0.7);
    }
  }

  .f-horizontal-line_frame {
    width: 100%;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.4);

    .f-horizontal-line {
      width: 45px;
      height: 1px;
      background: rgba(255, 255, 255, 0.3);
      margin-left: 7px;
    }
  }

  .fk_rightColorArrowsImg_prev {
  }

  .fk_rightColorArrowsImg_next {
    p {
      background-position: -45px 0;
    }
  }

  .fk_rightColorArrowsImg:hover {
    background-color: rgba(0, 0, 0, 0.6);

    p {
      opacity: 0.7;
    }
  }
}

.pagination_num_frame {
}

.big_block_btn_frame {
  z-index: 10;
  position: absolute;
  bottom: 20px;
  left: 0;
  text-align: center;
  font-size: 0;
  width: 100%;
  height: 15%;

  .one_big_block {
    display: inline-block;
    width: 11%;
    height: 100%;
    margin-right: 10px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    overflow: hidden;
    cursor: pointer;
    border: 3px solid;
    border-color: hsla(0, 0%, 100%, 0.4);
  }

  .big_block_btn_select {
    border-color: #fff;
  }
}

.imageSwitchBtnArea {
  position: absolute;
  z-index: 10;
  display: block;
  bottom: 24px;
  width: 100%;
  filter: url(#AR);
  font-size: 0;
  text-align: center;

  .fk_imageSwitchBtn_adsorptionRound {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 18px;
    padding: 0;
    line-height: 18px;
    background: #858585;
    color: #fff;
    border-radius: 100%;
    margin: 0 13px;
    font-size: 16px;
    font-family: Arial, Helvetica, sans-serif;
    cursor: pointer;
    vertical-align: top;

    .fk_adsorptionRound_num_current {
      position: relative;
      transform: translateZ(0) scale(1);
      animation: fk_adsorptionRound_num .6s ease-in;
      -webkit-animation: fk_adsorptionRound_num .6s ease;
    }

    span {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      text-align: center;
      transform: translateZ(0) scale(0);
      transition: all 0.8s;
      text-align: center;
    }

    .fk_adsorptionRound_num_activity {
      transform: translateZ(0) scale(1);
    }
  }

  .fk_adsorptionRound_current {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 18px;
    padding: 0;
    line-height: 18px;
    background: #858585;
    color: #fff;
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 50%;
    margin: 0 13px;
    font-size: 16px;
    cursor: pointer;
    transform: translate3d(45px, 0px, 0px) scale(1.5, 1.5);
    transition: all 0.8s;
    outline: 1px solid transparent;
  }

  svg {
    width: 100%;
  }

}

.imageSwitchBtnArea_clearFix:after {
  clear: both;
  content: "";
  display: table;
}

.imageSwitchBtnArea_clearFix:before {
  content: "";
  display: table;
}

@keyframes fk_adsorptionRound_num {
  0% {
    transform: translateZ(0) scale(0)
  }
  33% {
    transform: translateZ(0) scale(.33)
  }
  66% {
    transform: translateZ(0) scale(.66)
  }
  98% {
    transform: translateZ(0) scale(.98)
  }
}
</style>
<style lang="scss">
@import "./src/css/components/slideAnimation";

.full_screen_banner .swiper-slide, .my_banner .swiper-slide {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/widgets/full_screen_banner/index.vue